import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => (
    <footer className="p-3 mt-auto">
    </footer>
);

export default Footer;
